// iter416 — Dashboard "Money Movement" section: Cash & Bank balances,
// Inter-branch settlements, Payment-mode breakdown. Layout-only —
// each child component has its own data-fetch + render contract.
//
// Visibility rules are passed in via `widgets` (which also lives on the
// parent's persisted layout config) and `showWidget` (a permission +
// feature-flag check). InterBranch only renders when there's actual
// outstanding inter-branch debt either way.
import { DashboardSection } from './DashboardSection';
import CashBankWidget from '@/pages/dashboard/widgets/CashBankWidget';
import InterBranchWidget from '@/pages/dashboard/widgets/InterBranchWidget';
import PaymentModeWidget from '@/pages/dashboard/widgets/PaymentModeWidget';

export function MoneyMovementSection({
  stats,
  branches = [],
  paymentModeCards = [],
  fmtAmt,
  widgets = {},
  showWidget = () => true,
  onSettled,
}) {
  const hasInterBranchActivity =
    (stats?.inter_branch_owed_to_us || 0) > 0 ||
    (stats?.inter_branch_we_owe || 0) > 0;

  return (
    <DashboardSection title="Money Movement" testId="dash-section-money">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 items-start">
        {showWidget('cash_bank') && widgets.cashBank && (
          <CashBankWidget stats={stats} />
        )}
        {hasInterBranchActivity && (
          <InterBranchWidget stats={stats} branches={branches} onSettled={onSettled} />
        )}
      </div>
      {widgets.paymentMode && (
        <PaymentModeWidget paymentModeCards={paymentModeCards} fmtAmt={fmtAmt} />
      )}
    </DashboardSection>
  );
}

export default MoneyMovementSection;
